import React from 'react';

interface TaskSurfaceProps {
  task: string;
  completed: boolean;
  onToggle: () => void;
  taskIndicator?: string;
}

const TaskSurface: React.FC<TaskSurfaceProps> = ({
  task,
  completed,
  onToggle,
  taskIndicator,
}) => {
  return (
    <button
      className={`th-task ${completed ? 'is-done' : ''}`}
      onClick={onToggle}
      aria-label={completed ? `${task} (done)` : `Mark "${task}" done`}
      aria-pressed={completed}
    >
      <span className="th-task-text">{task}</span>
      {taskIndicator && !completed && (
        <span className="th-task-count">{taskIndicator}</span>
      )}
    </button>
  );
};

export default TaskSurface;
